import { AxiosRequestConfig, AxiosResponse } from 'axios'
import { ajax, params } from '@didi/driver-biz-sdk'
export interface BaseRes<T> {
  errno: number;
  errmsg: string;
  data: T;
}
export interface BaseURLmap {
  [key: string]: string;
  development: string;
  production: string;
}

const ip = params.urlParams.api
const baseDevelopmentIp = '//10.179.180.11:8991'
// 请求后端接口的url 公共部分。
const BASE_URL_MAP: BaseURLmap = {
  development: ip ? '//' + ip : baseDevelopmentIp,
  // development: '//maple.xiaojukeji.com',
  production: '//maple.xiaojukeji.com'
}
export const BASE_URL = BASE_URL_MAP[process.env.API_ENV || 'production']
/**
 * 初始化 ajax，是否需要签名，是否需要统一错误处理，默认只是判断 errno 是否为0
 *
 * 使用：
 * initAjax({
 *   needEncrypt: true,
 *   ERRNO: {
 *     loginExpire: [10001, 10002]
 *   },
 *   specialErrHandler: {
 *     loginExpire: function() {}
 *   }
 * })
 */
ajax.initAjax()

/**
 * 为所有请求添加拦截器，参考 https://github.com/axios/axios#interceptors
 * 比如这里我们对所有请求响应取 data 字段。
 * 【！注意！】你添加的 response 拦截器应该在 ajax.initAjax() 之后，否则会影响 initAjax 。
 */
export interface AxiosRequestConfigParams extends AxiosRequestConfig {
  useFormData?: unknown;
  useFormUrlencoded?: unknown;
}
ajax.axios.interceptors.request.use(function (config: AxiosRequestConfigParams) {
  if (config.method === 'post') {
    if (config.useFormData) {
      config.headers['Content-Type'] = 'multipart/form-data'
      const form = new FormData()
      try {
        for (const key in config.data) {
          form.append(key, config.data[key])
        }
        config.data = form
      } catch (e) {
        console.error('request formData', e)
      }
    } else if (config.useFormUrlencoded) {
      config.headers['Content-Type'] = 'application/x-www-form-urlencoded'
    } else {
      config.headers['Content-Type'] = 'application/json'
    }
    if (config.data.ticket) {
      config.headers.ticket = config.data.ticket
    }
  } else if (config.method === 'get') {
    if (config.params.ticket) {
      config.headers.ticket = config.params.ticket
    }
  }
  return config
})

ajax.axios.interceptors.response.use(function(res: AxiosResponse) {
  return res.data
})

/**
 * 封装所有接口，默认会给接口增加签名wigsig参数。
 * demo如下：
 * export const getData = ajax.get('/h5/data')
 *
 * 使用:
 * getData({
 *   parama: 1,
 *   paramb: 2
 * }, {
 *   needEncrypt: false // 关闭 ajax 签名
 *   timeout: 15000 // 支持 axios config 配置项，比如这里的 timeout
 * })
 */
export {
  ajax
}
